import { useConfirmDialogContext } from '../context/ConfirmDialogContext'

export const useConfirmDialog = () => {
    const context = useConfirmDialogContext()
    if (!context) {
        throw new Error('useConfirmDialog must be used within ConfirmDialogProvider')
    }

    return {
        confirm: context.confirm,
    }
}
